import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./CourtCheckout.css";
import Navbar from "../components/Navbar";
import { supabase } from "../supabase";
import { SST_RATE, SST_LABEL } from "../constants";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { parsePhoneNumber } from "libphonenumber-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const ConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Confirm Order</h2>
        <div className="modal-body">
          <p>By clicking Agree, you confirm all items in your order are correct.</p>
          <p>
            <strong>Refund Policy (Last updated: 05/06/2025):</strong><br />
            - Cancel anytime as long as it is not within 48 hours before the booking time for a full refund as credits.<br />
            - No refunds within 48 hours of the booking time.<br />
            - Credits are non-transferable, non-redeemable for cash.<br />
            - No cash refunds.<br />
            - For issues, contact <a href="mailto:info@pickledepot.com.my">info@pickledepot.com.my</a>.<br />
            Full Terms: <a href="https://www.pickledepot.com.my/_files/ugd/01db86_19a89a1d4ff843b39265478a620528a0.pdf" target="_blank" rel="noopener noreferrer">here</a>.
          </p>
        </div>
        <div className="modal-buttons">
          <button className="modal-close-button" onClick={onClose} aria-label="Cancel order confirmation">Cancel</button>
          <button className="modal-confirm-button" onClick={onConfirm} aria-label=" Agree to terms and confirm order"> Agree</button>
        </div>
      </div>
    </div>
  );
};

const CourtCheckout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    selectedSport,
    selectedCourtType,
    selectedDate,
    selectedCourtTimeSlots,
    selectedBookingType,
    selectedProfile,
    selectedAddOns,
  } = location.state || {};

  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [membershipStatus, setMembershipStatus] = useState(null);
  const [ytlRemainingQuota, setYtlRemainingQuota] = useState(null);
  const [prices, setPrices] = useState({});
  const [isPriceLoading, setIsPriceLoading] = useState(false);
  const [discountedTotal, setDiscountedTotal] = useState(0);
  const [availableCredits, setAvailableCredits] = useState(0);
  const [useCredits, setUseCredits] = useState(true);
  const [creditsToUse, setCreditsToUse] = useState(0);
  const [finalTotal, setFinalTotal] = useState(0);
  const [promoCode, setPromoCode] = useState('');
  const [promoCodeApplied, setPromoCodeApplied] = useState(null);
  const [promoDiscount, setPromoDiscount] = useState(0);
  const [isPromoLoading, setIsPromoLoading] = useState(false);
  const [promoError, setPromoError] = useState('');
  const [isPublicHoliday, setIsPublicHoliday] = useState(false);
  const [notification, setNotification] = useState({ message: "", show: false });
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [addOnItems, setAddOnItems] = useState([]);
  const [formData, setFormData] = useState({
    billingName: "",
    billingEmail: "",
    billingMobile: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const paymentFormRef = useRef(null);
  const phoneInputRef = useRef(null);
  const phoneInputContainerRef = useRef(null);

  const isFullyLoaded = !isLoading && (!isPriceLoading || selectedBookingType !== "court-booking");
  const fixedBillingAddress = "WS4, Sentul Depot, Jalan Strachan, Sentul West, 51100 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur";
  const memoizedLocationState = useMemo(() => location.state, [location.state]);

  const mapBookingType = (type) => {
    switch (type) {
      case "court-booking": return "court_booking";
      case "group-lesson": return "group_lesson";
      default: return null;
    }
  };

  const isSafari = () => {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('safari') && !ua.includes('chrome');
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };
  const handleChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  // const handleChange = useCallback(
  //   debounce((name, value) => {
  //     let normalizedValue = value;
  //     if (name === "billingMobile" && value) {
  //       try {
  //         const phoneNumber = parsePhoneNumber(value);
  //         if (phoneNumber && phoneNumber.isValid()) {
  //           normalizedValue = phoneNumber.formatInternational();
  //         }
  //       } catch (error) {
  //         console.error("CourtCheckout.js: Error normalizing phone number:", error);
  //         normalizedValue = value;
  //       }
  //     }
  //     setFormData((prev) => ({ ...prev, [name]: normalizedValue }));
  //     setFormErrors((prev) => {
  //       const errors = { ...prev };
  //       if (!normalizedValue || normalizedValue.trim() === "") {
  //         errors[name] = `${name.replace("billing", "Billing ")} is required`;
  //       } else {
  //         delete errors[name];
  //       }
  //       if (name === "billingName" && normalizedValue) {
  //         if (!/^[a-zA-Z0-9\s]+$/.test(normalizedValue)) {
  //           errors.billingName = "Billing Name must be alphanumeric";
  //         } else if (normalizedValue.length > 128) {
  //           errors.billingName = "Billing Name must be up to 128 characters";
  //         }
  //       }
  //       if (name === "billingEmail" && normalizedValue) {
  //         if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedValue)) {
  //           errors.billingEmail = "Invalid email format";
  //         } else if (normalizedValue.length > 128) {
  //           errors.billingEmail = "Billing Email must be up to 128 characters";
  //         }
  //       }
  //       if (name === "billingMobile" && normalizedValue) {
  //         const phoneError = validatePhoneNumber(normalizedValue);
  //         if (phoneError) {
  //           errors.billingMobile = phoneError;
  //         } else {
  //           delete errors.billingMobile;
  //         }
  //       }
  //       return errors;
  //     });
  //   }, 300),
  //   []
  // );

  const debouncedValidate = useRef(
    debounce((name, value) => {
      let normalizedValue = value;
      let errors = {};

      if (name === "billingMobile" && value) {
        try {
          const phoneNumber = parsePhoneNumber(value);
          if (phoneNumber?.isValid()) {
            normalizedValue = phoneNumber.formatInternational();
          }
        } catch {}
      }

      if (!normalizedValue?.trim()) {
        errors[name] = `${name.replace("billing", "Billing ")} is required`;
      }

      if (name === "billingName") {
        if (!/^[a-zA-Z0-9\s]+$/.test(normalizedValue)) {
          errors.billingName = "Billing Name must be alphanumeric";
        }
      }

      setFormErrors(prev => ({ ...prev, ...errors }));
      setFormErrors((prev) => {
        const errors = { ...prev };
        if (!normalizedValue || normalizedValue.trim() === "") {
          errors[name] = `${name.replace("billing", "Billing ")} is required`;
        } else {
          delete errors[name];
        }
        if (name === "billingName" && normalizedValue) {
          if (!/^[a-zA-Z0-9\s]+$/.test(normalizedValue)) {
            errors.billingName = "Billing Name must be alphanumeric";
          } else if (normalizedValue.length > 128) {
            errors.billingName = "Billing Name must be up to 128 characters";
          }
        }
        if (name === "billingEmail" && normalizedValue) {
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedValue)) {
            errors.billingEmail = "Invalid email format";
          } else if (normalizedValue.length > 128) {
            errors.billingEmail = "Billing Email must be up to 128 characters";
          }
        }
        if (name === "billingMobile" && normalizedValue) {
          const phoneError = validatePhoneNumber(normalizedValue);
          if (phoneError) {
            errors.billingMobile = phoneError;
          } else {
            delete errors.billingMobile;
          }
        }
        return errors;
      });
    }, 300)
  ).current;


  useEffect(() => {
    const checkInitialValues = () => {
      const billingNameInput = document.getElementById('billingName');
      if (billingNameInput && billingNameInput.value && !formData.billingName) {
        handleChange('billingName', billingNameInput.value);
        debouncedValidate('billingName', billingNameInput.value);
      }
      const billingEmailInput = document.getElementById('billingEmail');
      if (billingEmailInput && billingEmailInput.value && !formData.billingEmail) {
        handleChange('billingEmail', billingEmailInput.value);
        debouncedValidate('billingEmail', billingEmailInput.value);
      }
      if (phoneInputRef.current && phoneInputRef.current.value && !formData.billingMobile) {
        handleChange('billingMobile', phoneInputRef.current.value);
        debouncedValidate('billingMobile', phoneInputRef.current.value);
      }
    };
    setTimeout(checkInitialValues, 100);
  }, []);

  useEffect(() => {
    const checkSession = async () => {
      let hasRedirected = false;
      const redirectToLogin = () => {
        if (!hasRedirected) {
          hasRedirected = true;
          navigate("/login", { state: { from: location.pathname, ...memoizedLocationState } });
        }
      };
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        if (error || !session) {
          redirectToLogin();
          return;
        }
        setIsAuthenticated(true);
        const { data: user, error: userError } = await supabase.auth.getUser();
        if (userError || !user) {
          console.error("CourtCheckout.js: Error fetching user:", userError);
          // getUser() hits the network; when it fails because the connection
          // dropped (status 0 / "Load failed") the local session is still
          // valid and redirecting ping-pongs with Login's session check.
          // Only kick to /login when the server actually rejected the token.
          if (!userError || userError.status === 401 || userError.status === 403) {
            redirectToLogin();
          }
          return;
        }
        const { data: profileData, error: profileError } = await supabase
          .from("profiles")
          .select("membership_status")
          .eq("user_id", user.user.id)
          .single();
        if (profileError && profileError.code !== "PGRST116") {
          console.error("CourtCheckout.js: Error fetching profile:", profileError);
          redirectToLogin();
          return;
        }
        setMembershipStatus(profileData?.membership_status || "normal_member");

        // Fetch YTL staff discount remaining quota from bookings
        // Use the selected booking date's week, not the current date
        if (profileData?.membership_status === 'ytl_staff' && selectedDate) {
          // Convert to Malaysia time (UTC+8) before calculating week boundaries
          const localDate = new Date(selectedDate.getTime() + (8 * 60 * 60 * 1000));
          const day = localDate.getUTCDay();
          const weekStart = new Date(localDate);
          weekStart.setUTCDate(localDate.getUTCDate() - day + (day === 0 ? -6 : 1));
          const weekStartStr = weekStart.toISOString().split('T')[0];
          const weekEnd = new Date(weekStart);
          weekEnd.setUTCDate(weekEnd.getUTCDate() + 6);
          const weekEndStr = weekEnd.toISOString().split('T')[0];

          console.log(`ytl_staff quota check: selectedDate=${selectedDate}, localDate=${localDate.toISOString()}, week=${weekStartStr} to ${weekEndStr}`);

          const { data: weeklyBookings } = await supabase
            .from('bookings')
            .select('id, booking_date')
            .eq('user_id', user.user.id)
            .gte('booking_date', weekStartStr)
            .lte('booking_date', weekEndStr);

          console.log(`ytl_staff quota: found ${weeklyBookings?.length || 0} pickleball bookings this week`, weeklyBookings);
          setYtlRemainingQuota(Math.max(0, 2 - (weeklyBookings?.length || 0)));
        }

        const { data: creditsData, error: creditsError } = await supabase
          .from("credits")
          .select("balance")
          .eq("user_id", user.user.id)
          .single();
        if (creditsError) {
          if (creditsError.code === "PGRST116") setAvailableCredits(0);
          else {
            console.error("CourtCheckout.js: Error fetching credits:", creditsError);
            redirectToLogin();
            return;
          }
        } else {
          setAvailableCredits(creditsData?.balance || 0);
        }

        // Fetch latest order to autofill form
        const { data: orderData, error: orderError } = await supabase
          .from("orders")
          .select("billing_name, billing_email, billing_mobile")
          .eq("user_id", user.user.id)
          .order("created_at", { ascending: false })
          .limit(1)
          .single();
        if (orderError && orderError.code !== "PGRST116") {
          console.error("CourtCheckout.js: Error fetching latest order:", orderError);
        } else if (orderData) {
          setFormData({
            billingName: orderData.billing_name || "",
            billingEmail: orderData.billing_email || "",
            billingMobile: orderData.billing_mobile || "",
          });
        }
      } catch (error) {
        console.error("CourtCheckout.js: Unexpected error in checkSession:", error);
        redirectToLogin();
      } finally {
        setIsLoading(false);
      }
    };
    checkSession();
    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_OUT" || !session) {
        navigate("/login", { state: { from: location.pathname, ...memoizedLocationState } });
      }
    });
    return () => authListener.subscription.unsubscribe();
  }, [navigate, location.pathname, memoizedLocationState]);

  useEffect(() => {
    const checkPublicHoliday = async () => {
      if (selectedDate) {
        const localDate = new Date(selectedDate.getTime() + (8 * 60 * 60 * 1000));
        const bookingDateStr = localDate.toISOString().split("T")[0];
        const { data: holidayData } = await supabase
          .from("public_holidays")
          .select("date")
          .eq("date", bookingDateStr)
          .single();
        setIsPublicHoliday(!!holidayData);
      }
    };
    checkPublicHoliday();
  }, [selectedDate]);

  useEffect(() => {
    const fetchAddOnDetails = async () => {
      if (!selectedAddOns || selectedAddOns.length === 0) {
        setAddOnItems([]);
        return;
      }

      try {
        const addOnIds = selectedAddOns.map(item => item.add_on_id);
        const { data, error } = await supabase
          .from("add_ons")
          .select("id, name, price")
          .in("id", addOnIds);

        if (error) {
          console.error("CourtCheckout.js: Error fetching add-on details:", error);
          setAddOnItems([]);
          return;
        }

        const enrichedAddOns = selectedAddOns.map(selectedItem => {
          const itemDetails = data.find(d => d.id === selectedItem.add_on_id);
          return {
            ...selectedItem,
            name: itemDetails?.name || "Unknown Item",
            price: itemDetails?.price || 0,
          };
        });

        setAddOnItems(enrichedAddOns);
      } catch (err) {
        console.error("CourtCheckout.js: Failed to fetch add-on details:", err);
        setAddOnItems([]);
      }
    };

    fetchAddOnDetails();
  }, [selectedAddOns]);

  useEffect(() => {
    if (!phoneInputRef.current) return;
    const checkForAutofill = () => {
      const input = phoneInputRef.current;
      const currentValue = input.value;
      const stateValue = formData.billingMobile;
      if (currentValue && currentValue !== stateValue) {
        handleChange("billingMobile", currentValue || "");
        debouncedValidate("billingMobile", currentValue || "");
        
      }
      const billingNameInput = document.getElementById('billingName');
      if (billingNameInput && billingNameInput.value && billingNameInput.value !== formData.billingName) {
        handleChange('billingName', billingNameInput.value);
        debouncedValidate('billingName', billingNameInput.value);
      }
      const billingEmailInput = document.getElementById('billingEmail');
      if (billingEmailInput && billingEmailInput.value && billingEmailInput.value !== formData.billingEmail) {
        handleChange('billingEmail', billingEmailInput.value);
        debouncedValidate('billingEmail', billingEmailInput.value);
      }
    };
    const intervalTime = isSafari() ? 100 : 500;
    const interval = setInterval(checkForAutofill, intervalTime);
    const timeout = setTimeout(() => clearInterval(interval), 5000);
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [formData.billingMobile, formData.billingName, formData.billingEmail]);

  useEffect(() => {
    if (useCredits) {
      const maxCredits = Math.min(availableCredits, Math.max(0, discountedTotal - promoDiscount));
      setCreditsToUse(maxCredits);
    } else {
      setCreditsToUse(0);
    }
  }, [availableCredits, discountedTotal, useCredits, promoDiscount]);

  useEffect(() => {
    setPromoCodeApplied(null);
    setPromoDiscount(0);
    setPromoCode('');
    setPromoError('');
  }, [selectedCourtTimeSlots, selectedDate]);

  const handlePhoneBlur = () => {
    if (phoneInputRef.current) {
      const inputValue = phoneInputRef.current.value;
      if (inputValue && inputValue !== formData.billingMobile) {
        handleChange("billingMobile", inputValue || "");
        debouncedValidate("billingMobile", inputValue || "");
        
      }
    }
  };

  const formatDate = (date) => {
    if (!(date instanceof Date) || isNaN(date)) return "Invalid Date";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const parseTimeslot = (timeslot) => {
    const [time, period] = timeslot.split(" ");
    let [hours, minutes] = time.split(":").map(Number);
    let endHours = hours + 1;
    let endPeriod = period;
    if (hours === 12 && period === "PM") { endHours = 1; endPeriod = "PM"; }
    else if (hours === 12 && period === "AM") { endHours = 1; endPeriod = "AM"; }
    else if (endHours === 12) endPeriod = period === "AM" ? "PM" : "AM";
    else if (endHours > 12) { endHours -= 12; endPeriod = period === "AM" ? "PM" : "AM"; }
    const endTime = `${endHours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")} ${endPeriod}`;
    let formattedTimeslot = `${timeslot} - ${endTime}`;
    if (timeslot === "12:00 AM" || timeslot === "01:00 AM" || timeslot === "02:00 AM" || timeslot === "03:00 AM" || timeslot === "04:00 AM" || timeslot === "05:00 AM" || timeslot === "06:00 AM") formattedTimeslot += " (Next Day)";
    return formattedTimeslot;
  };

  const parseTimeslotForBackend = (timeslot) => {
    const [time, period] = timeslot.split(" ");
    let [hours, minutes] = time.split(":").map(Number);
    let endHours = hours + 1;
    let endPeriod = period;
    if (hours === 12 && period === "PM") { endHours = 1; endPeriod = "PM"; }
    else if (hours === 12 && period === "AM") { endHours = 1; endPeriod = "AM"; }
    else if (endHours === 12) endPeriod = period === "AM" ? "PM" : "AM";
    else if (endHours > 12) { endHours -= 12; endPeriod = period === "AM" ? "PM" : "AM"; }
    const endTime = `${endHours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")} ${endPeriod}`;
    return `${timeslot} - ${endTime}`;
  };

  const calculatePriceFallback = (membershipStatus, sport, courtType, timeslot, bookingDate) => {
    const isPeakHour = (timeslot, bookingDate)=>{
      if (isPublicHoliday) return true;
      const [time, period] = timeslot.split(" ");
      let [hours] = time.split(":").map(Number);
      if (period === "PM" && hours !== 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;
      const dayOfWeek = bookingDate.getDay();
      const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
      const isSunday = dayOfWeek === 0;
      if (isSunday) {
        // Sunday: whole day is peak, except 6pm–2am
        return !(hours >= 18 || hours < 2);
      } else if (isWeekend) {
        // Saturday: whole day is peak
        return true;
      } else {
        // Monday-Friday: 6am–11am and 6pm–2am are peak
        return (hours >= 6 && hours < 11) || (hours >= 18 || hours < 2);
      }
    };

    const isSuperHostHour = (timeslot) => {
      const [time, period] = timeslot.split(" ");
      let [hours] = time.split(":").map(Number);
      if (period === "PM" && hours !== 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;
      return hours < 18 && hours > 6;
    }

    let basePrice, peakPrice;
    let discountPrice = 0;
    if (courtType === "Tournament Court") {
      basePrice = 60;
      peakPrice = 80;
    } else if (courtType === "Show Court") {
      basePrice = 120;
      peakPrice = 120;
    } else if (courtType === "Padel Court") {
      basePrice = 120;
      peakPrice = 160;
      if (membershipStatus === "vip_maserati"){
        discountPrice = 10;
      }
    } else {
      return {
        beforeDiscountPrice: 0,
        finalPrice: 0,
        discountPrice: 0
      };
    }

    let finalPrice = basePrice;
    
    const isPeak = isPeakHour(timeslot, bookingDate);
    if (isPeak){
      finalPrice = peakPrice;
    }
    // if (courtType !== "Show Court") {
    //   const isPeak = isPeakHour(timeslot, bookingDate);
    //   if (isPeak) {
    //     finalPrice = peakPrice;
    //   }
    // }

    // Apply June off-peak discount for Tournament Courts
    // if (courtType === "Tournament Court" && bookingDate.getMonth() === 5 && bookingDate.getFullYear() === 2025) {
    //   const isPeak = isPeakHour(timeslot, bookingDate);
    //   if (!isPeak) {
    //     finalPrice = Math.max(0, finalPrice - 10);
    //   }
    // }

    // Apply July / August discount for Padel Courts
    // if (courtType === "Padel Court" && (bookingDate.getMonth() === 6 || bookingDate.getMonth() === 7) && bookingDate.getFullYear() === 2025) {
    //   finalPrice = Math.max(0, finalPrice - 20);
    // }


    // 2025-08-20 Joe: Configure superhost only need RM 50 for before 6pm, assuming 2am is consider today, so dont allow that also
    if ((membershipStatus === "super_host" || membershipStatus === 'super_host_pickle') && isSuperHostHour(timeslot) && courtType === "Tournament Court") {
      discountPrice = 20;
      // if (isPeak){
      //   discountPrice = 20;
      // }else{
      //   finalPrice = 40;
      // }
    }

    if ((membershipStatus === "super_host" || membershipStatus === 'super_host_padel') && isSuperHostHour(timeslot) && courtType === "Padel Court") {
      // if (isPeak) {
      //   finalPrice = 140;
      // } else {
      //   finalPrice = 100;
      // }
      discountPrice = 20;
    }

    return {
      beforeDiscountPrice: finalPrice,
      finalPrice: finalPrice - discountPrice,
      discountPrice: discountPrice
    };
  };

  useEffect(() => {
    if (!isAuthenticated || isLoading || selectedBookingType !== "court-booking" || !selectedCourtTimeSlots) return;
    let isCancelled = false;
    const fetchAllPrices = async () => {
      setIsPriceLoading(true);
      const effectiveCourtType = selectedSport === "Padel" ? "Padel Court" : selectedCourtType || "Tournament Court";
      const timeslotObject = Object.fromEntries(selectedCourtTimeSlots);

      console.log("selected court timeslots:", timeslotObject);
      console.log("body:", {court_timeslots: timeslotObject, selected_sport: selectedSport, court_type: effectiveCourtType, date: selectedDate, add_ons: selectedAddOns});

      // Refresh session before invoking edge function to prevent 401 from expired JWT
      const { data: { session: priceSession }, error: priceSessionError } = await supabase.auth.getSession();
      if (priceSessionError || !priceSession) {
        setNotification({ message: "Your session has expired. Please log in again.", show: true });
        navigate("/login", { state: { from: location.pathname, ...memoizedLocationState } });
        return;
      }
      
      const { data: calculatePriceResponse, error: calculatePriceError } = await supabase.functions.invoke("client-calculate-price-v5", {
        body: {court_timeslots: timeslotObject, selected_sport: selectedSport, court_type: effectiveCourtType, date: selectedDate, add_ons: selectedAddOns || []},
      });
      if (calculatePriceResponse){
        console.log("calculate price:", calculatePriceResponse);
        setPrices(calculatePriceResponse);

      }else if(calculatePriceError){
        console.error("CourtCheckout.js: Failed to fetch pricing", calculatePriceError);
        setNotification({ message: "Failed to get pricing, please try to refresh the page", show: true });
      }

      setIsPriceLoading(false);
    };
    fetchAllPrices();
    return () => { isCancelled = true; };
  }, [isAuthenticated,
    isLoading,
    selectedCourtTimeSlots,
    selectedSport,
    selectedCourtType,
    selectedDate,
    isPublicHoliday,
    selectedAddOns]);

  const generateOrderItems = useCallback(() => {
    if (!isAuthenticated || !isFullyLoaded) return [];
    if (!selectedDate || !(selectedDate instanceof Date) || isNaN(selectedDate)) {
      console.error("CourtCheckout.js: Invalid selectedDate:", selectedDate);
      return [];
    }
    console.log("CourtCheckout.js: Generating order items with", { selectedSport, selectedCourtType, selectedBookingType, selectedDate, selectedCourtTimeSlots });
    const items = [];
    if (selectedBookingType === "court-booking" && selectedSport && selectedDate && selectedCourtTimeSlots) {
      const effectiveCourtType = selectedSport === "Padel" ? "Padel Court" : selectedCourtType || "Tournament Court";
      
      for (const [key, value] of selectedCourtTimeSlots) {
        const courtItems = value.map((timeslot, index) => {
          const priceData = prices[key]?.[timeslot] || calculatePriceFallback(membershipStatus, selectedSport, effectiveCourtType, timeslot, selectedDate);

          items.push({
            id: `booking_${key}_${index + 1}`,
            type: "Court Booking",
            details: `${selectedSport} ${effectiveCourtType} #${key}\n${formatDate(selectedDate)}, ${parseTimeslot(timeslot)}`,
            detailsForBackend: `${selectedSport} ${effectiveCourtType} #${key}\n${formatDate(selectedDate)}, ${parseTimeslotForBackend(timeslot)}`,
            price: priceData.finalPrice,
            membershipDiscountPrice: priceData.membershipDiscountPrice,
            companyDiscountPrice: priceData.companyDiscountPrice,
            isFreeSlot: priceData.price === 0,
            basePrice: priceData.beforeDiscountPrice,
          });

          if (priceData.companyDiscountPrice > 0){
            items.push({
              id: `booking_discount_${key}_${index + 1}`,
              type: "Promotion Discount",
              details: `(until 31 Dec 2026)`,
              detailsForBackend: `Discount (until 31 Dec 2026)`,
              price: priceData.finalPrice,
              membershipDiscountPrice: priceData.membershipDiscountPrice,
              companyDiscountPrice: priceData.companyDiscountPrice,
              isFreeSlot: priceData.price === 0,
              basePrice: priceData.beforeDiscountPrice,
            });
          }

          if (priceData.membershipDiscountPrice > 0){
            const membershipLabel = membershipStatus.split("_").map(word =>                      // Capitalize each word
              word.charAt(0).toUpperCase() + word.slice(1)
            ).join(" ").replace("Pickle", "").replace("Padel", "");
            items.push({
              id: `booking_discount_${key}_${index + 1}`,
              type: "Membership Discount",
              details: `${membershipLabel}`,
              detailsForBackend: `Discount - ${membershipLabel}`,
              price: priceData.finalPrice,
              membershipDiscountPrice: priceData.membershipDiscountPrice,
              companyDiscountPrice: priceData.companyDiscountPrice,
              isFreeSlot: priceData.price === 0,
              basePrice: priceData.beforeDiscountPrice,
            });
          }

          // return {
          //   id: `booking_${key}_${index + 1}`,
          //   type: "Court Booking",
          //   details: `${selectedSport} ${effectiveCourtType} #${key}\n${formatDate(selectedDate)}, ${parseTimeslot(timeslot)}`,
          //   detailsForBackend: `${selectedSport} ${effectiveCourtType} #${key}\n${formatDate(selectedDate)}, ${parseTimeslotForBackend(timeslot)}`,
          //   price: priceData.finalPrice,
          //   discountPrice: priceData.discountPrice,
          //   isFreeSlot: priceData.price === 0,
          //   basePrice: priceData.beforeDiscountPrice,
          // };
        });
        // items.push(...courtItems)
      }
      // Apply August discount for Padel Courts
      const localDate = new Date(selectedDate.getTime() + (8 * 60 * 60 * 1000));
      // 2025-08-16 Joe: No longer add discount in another row, just direct minus from final price
      // if (effectiveCourtType === "Padel Court" && localDate.getMonth() === 7 && localDate.getFullYear() === 2025) {
      //   const eligibleItems = items.filter(item => item.type === "Court Booking");
      //   if (eligibleItems.length > 0) {
      //     const totalDiscount = eligibleItems.length * 20;
      //     if (totalDiscount > 0) {
      //       items.push({
      //         id: "august-padel-discount",
      //         type: "Discount",
      //         details: "Padel Court August Discount",
      //         detailsForBackend: "Padel Court August Discount",
      //         price: -totalDiscount,
      //         isFreeSlot: false,
      //       });
      //     }
      //   }
      // }
      if (useCredits && creditsToUse > 0) {
        items.push({
          id: "credits",
          type: "Credits Applied",
          details: `Credits Used`,
          detailsForBackend: `Credits Used`,
          price: -creditsToUse,
          isFreeSlot: false,
        });
      }
    }

    // Add add-on items to the order
    if (addOnItems && addOnItems.length > 0) {
      addOnItems.forEach((addOn, index) => {
        items.push({
          id: `addon_${addOn.add_on_id}_${index}`,
          type: "Add-On",
          details: `${addOn.name} (x${addOn.quantity})`,
          detailsForBackend: `Add-On: ${addOn.name} (x${addOn.quantity})`,
          price: addOn.price * addOn.quantity,
          basePrice: addOn.price * addOn.quantity,
          isFreeSlot: false,
        });
      });
    }

    // console.log("CourtCheckout.js: Final order items:", items);
    return items;
  }, [
    isAuthenticated,
    isFullyLoaded,
    selectedBookingType,
    selectedSport,
    selectedDate,
    selectedCourtTimeSlots,
    selectedCourtType,
    isPublicHoliday,
    useCredits,
    creditsToUse,
    addOnItems,
  ]);

  const orderItems = useMemo(() => generateOrderItems(), [generateOrderItems]);

  const addOnSubtotal = useMemo(() => {
    return orderItems
      .filter(item => item.type === "Add-On")
      .reduce((acc, item) => acc + item.price, 0);
  }, [orderItems]);

  const calcTotals = useCallback(() => {
    const discountedTotalAmount = orderItems
      .filter(item => item.type !== "Credits Applied" && item.type !== "Membership Discount" && item.type !== "Promotion Discount")
      .reduce((acc, item) => acc + item.price, 0);
    setDiscountedTotal(discountedTotalAmount < 0 ? 0 : discountedTotalAmount);
    const finalAmount = Math.max(0, discountedTotalAmount - promoDiscount - (useCredits ? creditsToUse : 0));
    console.log("final amount:", finalAmount);
    setFinalTotal(finalAmount);
  }, [orderItems, useCredits, creditsToUse, promoDiscount]);

  useEffect(() => {
    calcTotals();
  }, [calcTotals]);

  const handleApplyPromoCode = async () => {
    if (!promoCode.trim()) return;
    setIsPromoLoading(true);
    setPromoError('');

    try {
      const session = await supabase.auth.getSession();
      const token = session.data.session?.access_token;

      const orderAmount = discountedTotal;

      // Booking context for promo constraints (time-of-day / sport / booking-type).
      // selectedCourtTimeSlots is an array of [courtKey, timeslots[]] pairs; the
      // slot strings are already in "HH:MM AM|PM" form.
      const allTimeslots = Array.isArray(selectedCourtTimeSlots)
        ? selectedCourtTimeSlots.flatMap(([, slots]) => (Array.isArray(slots) ? slots : []))
        : [];
      const localDate = new Date(selectedDate.getTime() + (8 * 60 * 60 * 1000));
      const bookingDate = `${localDate.getFullYear()}-${String(localDate.getMonth() + 1).padStart(2, "0")}-${String(localDate.getDate()).padStart(2, "0")}`;

      const response = await fetch(
        'https://api.pickledepot.com.my/functions/v1/validate-promo-code',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'apikey': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im12dmhycGZhY2dtbmZpZ254dGtiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUwNjIzNjAsImV4cCI6MjA2MDYzODM2MH0.mHAiPSOC3pS5vTBcQB-__TsziwT30gnyI9aVuxeSazw'
          },
          body: JSON.stringify({
            code: promoCode.trim(),
            order_amount: orderAmount,
            booking_type: 'court_booking',
            sport_name: selectedSport,
            timeslots: allTimeslots,
            booking_date: bookingDate,
          })
        }
      );

      const data = await response.json();

      if (data.valid) {
        setPromoCodeApplied(data);
        setPromoDiscount(data.discount_amount);
        setPromoError('');
      } else {
        setPromoError(data.error || 'Invalid promo code');
        setPromoCodeApplied(null);
        setPromoDiscount(0);
      }
    } catch (err) {
      setPromoError('Failed to validate promo code. Please try again.');
    } finally {
      setIsPromoLoading(false);
    }
  };

  const handleRemovePromoCode = () => {
    setPromoCode('');
    setPromoCodeApplied(null);
    setPromoDiscount(0);
    setPromoError('');
  };

  const handleCreditsToggle = () => {
    setUseCredits(!useCredits);
    if (!useCredits) {
      const maxCredits = Math.min(availableCredits, Math.max(0, discountedTotal - promoDiscount));
      setCreditsToUse(maxCredits);
    } else {
      setCreditsToUse(0);
    }
  };

  const validatePhoneNumber = (value) => {
    if (!value) return "Billing Mobile is required";
    try {
      const phoneNumber = parsePhoneNumber(value);
      if (!phoneNumber || !phoneNumber.isValid()) return "Invalid phone number (e.g., +12025550123)";
      return null;
    } catch (error) {
      console.error("CourtCheckout.js: Error validating phone number:", error);
      return "Invalid phone number format";
    }
  };

  const validateForm = () => {
    const errors = {};
    Object.keys(formData).forEach((name) => {
      if (!formData[name] || formData[name].trim() === "") {
        errors[name] = `${name.replace("billing", "Billing ")} is required`;
      }
      if (name === "billingName" && formData[name]) {
        if (!/^[a-zA-Z0-9\s]+$/.test(formData[name])) {
          errors.billingName = "Billing Name must be alphanumeric";
        } else if (formData[name].length > 128) {
          errors.billingName = "Billing Name must be up to 128 characters";
        }
      }
      if (name === "billingEmail" && formData[name]) {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData[name])) {
          errors.billingEmail = "Invalid email format";
        } else if (formData[name].length > 128) {
          errors.billingEmail = "Billing Email must be up to 128 characters";
        }
      }
      if (name === "billingMobile" && formData[name]) {
        const phoneError = validatePhoneNumber(formData[name]);
        if (phoneError) errors.billingMobile = phoneError;
      }
    });
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const generateOrderId = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    const uuid = crypto.randomUUID().replace(/-/g, '').substring(0, 8);
    const timestamp = Date.now();
    return `order_${uuid}_${timestamp}`.substring(0, 40);
  };

  const checkBookingConflict = async (courtId, bookingDate, timeslots) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        console.error("CourtCheckout.js: No authenticated user found");
        return { conflict: false, message: null };
      }
      const currentUserId = user.id;
      const conflictPromises = [
        supabase
          .from("bookings")
          .select("timeslot")
          .eq("court_id", courtId)
          .eq("booking_date", bookingDate)
          .in("timeslot", timeslots),
        supabase
          .from("pending_bookings")
          .select("timeslot, user_id")
          .eq("court_id", courtId)
          .eq("booking_date", bookingDate)
          .in("timeslot", timeslots)
          .gt("expires_at", new Date().toISOString())
          .neq("user_id", currentUserId),
        supabase
          .from("pending_bookings")
          .select("timeslot, order_id")
          .eq("court_id", courtId)
          .eq("booking_date", bookingDate)
          .eq("user_id", currentUserId)
          .in("timeslot", timeslots)
          .gt("expires_at", new Date().toISOString())
      ];
      const [existingBookings, activeReservations, userPendingCredits] = await Promise.all(conflictPromises);
      if (existingBookings.error || activeReservations.error || userPendingCredits.error) {
        console.error("CourtCheckout.js: Error checking conflicts:", existingBookings.error || activeReservations.error || userPendingCredits.error);
        return { conflict: false, message: null };
      }
      if (existingBookings.data.length > 0) {
        return { conflict: true, message: "Failed to make booking. The selected timeslot is already taken. Please choose a different timeslot or date." };
      }
      if (activeReservations.data.length > 0) {
        return { conflict: true, message: "Failed to make booking. The selected timeslot is currently being processed by another user. Please try again later or choose a different timeslot." };
      }
      if (userPendingCredits.data.length > 0) {
        return { conflict: false, existingOrderId: userPendingCredits.data[0].order_id };
      }
      return { conflict: false, message: null };
    } catch (error) {
      console.error("CourtCheckout.js: Unexpected error checking conflicts:", error);
      return { conflict: false, message: null };
    }
  };

  const updateFreeSlotsUsage = async (userId, bookingDate) => {
    const weekStart = new Date(bookingDate);
    weekStart.setDate(weekStart.getDate() - weekStart.getDay() + (weekStart.getDay() === 0 ? -6 : 1));
    const weekStartStr = weekStart.toISOString().split("T")[0];
    const { data: freeSlotData, error: fetchError } = await supabase
      .from("free_slots")
      .select("slots_used")
      .eq("user_id", userId)
      .eq("week_start", weekStartStr)
      .single();
    if (fetchError && fetchError.code !== "PGRST116") {
      console.error("CourtCheckout.js: Error fetching free slots:", fetchError);
      return;
    }
    const maxFreeTimeslots = 2;
    if (freeSlotData?.slots_used >= maxFreeTimeslots && membershipStatus === 'athlete') {
      throw new Error("Maximum free slots exceeded for this week.");
    }
    if (!freeSlotData) {

      const { data: insertSlotResponse, error: insertSlotError } = await supabase.functions.invoke("client-insert-free-slot-usage", {
        body: { week_start: weekStartStr, slots_used: 1 },
      });
      // await supabase.from("free_slots").insert({ user_id: userId, week_start: weekStartStr, slots_used: 1 });
    } else {

      const { data: updateSlotResponse, error: updateSlotError } = await supabase.functions.invoke("client-update-free-slot-usage", {
        body: { slots_used: freeSlotData.slots_used + 1, week_start: weekStartStr},
      });

      // await supabase.from("free_slots").update({ slots_used: freeSlotData.slots_used + 1 }).eq("user_id", userId).eq("week_start", weekStartStr);
    }
  };

  // const updateUserCredits = async (userId, creditsUsed) => {
  //   try {
  //     const { data: creditsData, error: fetchError } = await supabase
  //       .from("credits")
  //       .select("balance")
  //       .eq("user_id", userId)
  //       .single();
  //     if (fetchError) {
  //       if (fetchError.code === "PGRST116") {
  //         const newBalance = Math.max(0, -creditsUsed);
  //         const { error: insertError } = await supabase
  //           .from("credits")
  //           .insert({ user_id: userId, balance: newBalance, created_at: new Date().toISOString(), updated_at: new Date().toISOString() });
  //         if (insertError) {
  //           console.error("CourtCheckout.js: Error inserting new credits record:", insertError);
  //           return false;
  //         }
  //         setAvailableCredits(newBalance);
  //         return true;
  //       } else {
  //         console.error("CourtCheckout.js: Error fetching user credits:", fetchError);
  //         return false;
  //       }
  //     }
  //     const newCredits = Math.max(0, creditsData.balance - creditsUsed);
  //     const { error: updateError } = await supabase
  //       .from("credits")
  //       .update({ balance: newCredits, updated_at: new Date().toISOString() })
  //       .eq("user_id", userId);
  //     if (updateError) {
  //       console.error("CourtCheckout.js: Error updating user credits:", updateError);
  //       return false;
  //     }
  //     setAvailableCredits(newCredits);
  //     return true;
  //   } catch (error) {
  //     console.error("CourtCheckout.js: Unexpected error updating credits:", error);
  //     return false;
  //   }
  // };

  const cleanupExpiredCreditsForUser = async (userId) => {
    try {
      const now = new Date().toISOString();
      const { data: expiredReservations, error: fetchError } = await supabase
        .from("pending_credits_deduction")
        .select("order_id")
        .eq("user_id", userId)
        .lt("expires_at", now);
      if (fetchError) {
        console.error("CourtCheckout.js: Error fetching expired credit reservations for user:", fetchError);
        return false;
      }
      if (expiredReservations && expiredReservations.length > 0) {
        const orderIds = expiredReservations.map(reservation => reservation.order_id);

        const { data: cleanUpResponse, error: cleanUpError } = await supabase.functions.invoke("client-delete-pending-credits-deduction", {
          body: { order_ids: orderIds},
        });
        // await supabase.from("pending_credits_deduction").delete().eq("user_id", userId).in("order_id", orderIds);
        console.log(`CourtCheckout.js: Cleaned up ${expiredReservations.length} expired credit reservations for user ${userId}`);
      }
      return true;
    } catch (error) {
      console.error("CourtCheckout.js: Unexpected error cleaning up expired credits:", error);
      return false;
    }
  };

  const reserveCredits = async (userId, orderId, credits) => {
    try {
      const insertData = { order_id: orderId, credits };
      const expiresAt = new Date();
      expiresAt.setMinutes(expiresAt.getMinutes() + 3);
      insertData.expires_at = expiresAt.toISOString();
      const { data: reserveResponse, error: reserveError } = await supabase.functions.invoke("client-insert-pending-credits-deduction", {
        body: { insert_data: insertData},
      });
      // const { error } = await supabase.from("pending_credits_deduction").insert(insertData);
      if (reserveError) {
        console.error("CourtCheckout.js: Error reserving credits:", reserveError);
        return false;
      }
      return true;
    } catch (error) {
      console.error("CourtCheckout.js: Unexpected error reserving credits:", error);
      return false;
    }
  };

  const insertFreeBooking = async (user, orderId, bookingType, bookingMetadata) => {
    try {
      console.log("inserting free booking");
      if (bookingType === "court_booking") {
        const { court_id, booking_date, timeslots, user_id } = bookingMetadata;
        if (timeslots.length > 0) {
          const bookingsToInsert = timeslots.map(timeslot => ({
            court_id,
            booking_date,
            timeslot,
            booking_type: "court_booking",
            order_id: orderId,
          }));
          // await supabase.from("bookings").insert(bookingsToInsert);

          const { data: insertBookingResponse, error: insertBookingError } = await supabase.functions.invoke("client-insert-booking-timeslots", {
            body: {bookings_to_insert: bookingsToInsert},
          });

          // Conflict check start
          if (insertBookingError) {
          }
          await Promise.all(timeslots.map(timeslot => updateFreeSlotsUsage(user_id, booking_date)));
        }
      } else if (bookingType === "group_lesson") {
        const { schedules, user_id } = bookingMetadata;
        const bookingsToInsert = await Promise.all(
          schedules.map(async (schedule) => {
            const { instance_id, court_id, booking_date, timeslot } = schedule;

            const { data: updateProgramScheduleInstancesResponse, error: updateProgramScheduleInstancesError } = await supabase.functions.invoke("client-increment-group-lesson-count", {
              body: schedule,
            });
            // await supabase.from("program_schedule_instances").update({ participants: supabase.rpc("increment_participants", { instance_id }) }).eq("id", instance_id);
            return {
              court_id,
              booking_date,
              timeslot,
              booking_type: "group_lesson",
              program_schedule_instance_id: instance_id,
              order_id: orderId,
            };
          })
        );

        const { data: insertBookingResponse, error: insertBookingError } = await supabase.functions.invoke("client-insert-booking-timeslots", {
          body: bookingsToInsert,
        });
        
        // await supabase.from("bookings").insert(bookingsToInsert);
      }
      return { success: true };
    } catch (error) {
      console.error("CourtCheckout.js: Error in insertFreeBooking:", error);
      if (bookingType === "group_lesson") {
        const { schedules } = bookingMetadata;
        await Promise.all(schedules.map(schedule => 
          
          supabase.functions.invoke("client-decrement-group-lesson-count", {
            body: schedule,
          })
          // supabase
          // .from("program_schedule_instances")
          // .update({ participants: supabase.rpc("decrement_participants", { instance_id: schedule.instance_id }) })
          // .eq("id", schedule.instance_id)
        ));
      }
      return { success: false, message: error.message };
    }
  };

  const handleCloseNotification = () => {
    setNotification({ message: "", show: false });
  };

  const handlePlaceOrder = (event) => {
    event.preventDefault();
    setShowConfirmationModal(true);
  };

  const handleSubmit = async (event) => { 
    if (event) event.preventDefault(); // Prevent hidden form submit

    setShowConfirmationModal(false);
    setIsProcessing(true);

    if (phoneInputRef.current) {
      phoneInputRef.current.blur();
    }

    if (!validateForm()) {
      setNotification({ message: "Please fill in all required fields correctly.", show: true });
      setIsProcessing(false);
      return;
    }

    // if (selectedBookingType === "court-booking") {
    //   if (selectedTimeslots.some(timeslot => !prices[timeslot])) {
    //     setNotification({ message: "Please wait while prices are loading.", show: true });
    //     return;
    //   }
    // }

    // const allTimeslotsPriced = selectedTimeslots.every(timeslot => prices[timeslot] !== undefined);
    // if (!allTimeslotsPriced) {
    //   setNotification({ message: "Please wait while we load the prices for all selected timeslots.", show: true });
    //   return;
    // }

    // Refresh session before payment flow to prevent 401 from expired JWT
    const { data: { session: orderSession }, error: orderSessionError } = await supabase.auth.getSession();
    if (orderSessionError || !orderSession) {
      setNotification({ message: "Your session has expired. Please log in again.", show: true });
      setIsProcessing(false);
      navigate("/login", { state: { from: location.pathname, ...memoizedLocationState } });
      return;
    }

    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      setIsProcessing(false);
      navigate("/login", { state: { from: location.pathname, ...memoizedLocationState } });
      return;
    }

    // This order id is the group main id
    let orderId = await generateOrderId();
    const sanitizeDescription = (desc) => desc.replace(/[^a-zA-Z0-9\s;-]/g, "").substring(0, 128); // Limit to 128 chars
    const billDesc = sanitizeDescription(orderItems.map((item) => `${item.type} - ${item.detailsForBackend.replace(/\n/g, "; ")}`).join("; "));

    const bookingType = mapBookingType(selectedBookingType);
    if (!bookingType) {
      setNotification({ message: "Invalid booking selection. Please choose court booking or group lesson and try again.", show: true });
      setIsProcessing(false);
      return;
    }

    let orderBodies = [];
    if (selectedBookingType === "court-booking") {
      const localDate = new Date(selectedDate.getTime() + (8 * 60 * 60 * 1000));
      const bookingDate = `${localDate.getFullYear()}-${String(localDate.getMonth() + 1).padStart(2, "0")}-${String(localDate.getDate()).padStart(2, "0")}`;
      let currentCreditsToUse = creditsToUse;
      for (const [courtKey, timeslots] of selectedCourtTimeSlots) {
        let courtOrderId = await generateOrderId();
        
        const effectiveCourtType = selectedSport === "Padel" ? "Padel Court" : selectedCourtType || "Tournament Court";
        
        const courtItems = timeslots.map((timeslot, index) => {
          const priceData = prices[courtKey]?.[timeslot] || calculatePriceFallback(membershipStatus, selectedSport, effectiveCourtType, timeslot, selectedDate);
          return priceData;
        });
        let currentOrderFinalTotal = courtItems.reduce((acc, item) => acc + item.finalPrice, 0);
        const courtName = `${selectedSport === "Padel" ? "Padel Court" : selectedCourtType || "Tournament Court"} ${courtKey}`;

        const { data: courtData, error: courtError } = await supabase
          .from("courts")
          .select("id")
          .eq("name", courtName)
          .single();

        if (courtError || !courtData) {
          console.error("CourtCheckout.js: Failed to fetch court_id", { courtError, courtName });
          setNotification({ message: "Failed to make booking. The selected court is unavailable. Please choose a different court or try again later.", show: true });
          setIsProcessing(false);
          return;
        }

        const courtId = courtData.id;

        const { data: existingBookings, error: bookingError } = await supabase
          .from("bookings")
          .select("id")
          .eq("court_id", courtId)
          .eq("booking_date", bookingDate)
          .eq("user_id", user.id)
          .in("timeslot", timeslots);

        if (bookingError) {
          console.error("CourtCheckout.js: Error checking existing bookings:", bookingError);
        } else if (existingBookings.length > 0) {
          setNotification({ message: "You already have a confirmed booking for this timeslot. Redirecting to profile.", show: true });
          setIsProcessing(false);
          setTimeout(() => navigate("/profile", { state: { selectedProfile: true } }), 2000);
          return;
        }

        const { conflict, message, existingOrderId } = await checkBookingConflict(courtId, bookingDate, timeslots);
        if (conflict) {
          setNotification({ message, show: true });
          setIsProcessing(false);
          return;
        }

        if (existingOrderId) {
          orderId = existingOrderId;
        }

        const freeTimeslots = timeslots.filter((timeslot) => prices[timeslot]?.price === 0);
        if (!existingOrderId && freeTimeslots.length > 0) {
          const { success, message: freeBookingMessage } = await insertFreeBooking(user, orderId, bookingType, {
            court_id: courtId,
            booking_date: bookingDate,
            timeslots: freeTimeslots,
            user_id: user.id,
          });
          if (!success) {
            setNotification({ message: freeBookingMessage || "Failed to confirm free booking. Please try again.", show: true });
            setIsProcessing(false);
            return;
          }
        }

        const paidTimeslots = timeslots.filter((timeslot) => prices[courtKey]?.[timeslot]?.price > 0);
        let bookingMetadata = {
          type: "court_booking",
          user_id: user.id,
          court_id: courtId,
          booking_date: bookingDate,
          timeslots: paidTimeslots.length > 0 ? paidTimeslots : timeslots,
        };
        if (useCredits && currentCreditsToUse > 0){
          if (currentCreditsToUse > currentOrderFinalTotal){
            bookingMetadata.credits_to_use = currentOrderFinalTotal;
          }else{
            bookingMetadata.credits_to_use = currentCreditsToUse;
          }
          currentCreditsToUse = Math.max(0, currentCreditsToUse - currentOrderFinalTotal);
        }

        orderBodies.push({
          order_id: courtOrderId,
          parent_order_id: orderId,
          total_amount: currentOrderFinalTotal, // Record original total for backend
          status: currentOrderFinalTotal > 0 ? "pending" : "completed",
          billing_name: formData.billingName,
          billing_email: formData.billingEmail,
          billing_mobile: formData.billingMobile.replace(/\s/g, ""),
          billing_address: fixedBillingAddress,
          booking_metadata: bookingMetadata,
        });
      }
    } else {
      setNotification({ message: "Invalid booking selection. Please choose court booking or group lesson and try again.", show: true });
      setIsProcessing(false);
      return;
    }

    const orderRequestBody = {
      order_id: orderId,
      total_amount: finalTotal, // Record original total for backend
      status: finalTotal > 0 ? "pending" : "completed",
      billing_name: formData.billingName,
      billing_email: formData.billingEmail,
      billing_mobile: formData.billingMobile.replace(/\s/g, ""),
      billing_address: fixedBillingAddress,
      booking_metadata: {},
      add_ons: selectedAddOns && selectedAddOns.length > 0 ? selectedAddOns : [],
    };
    if (finalTotal > 0) {
      if (useCredits && creditsToUse > 0) {
        const cleanupSuccess = await cleanupExpiredCreditsForUser(user.id);
        if (!cleanupSuccess) {
          setNotification({ message: "Failed to clean up expired credit reservations. Please try again or contact support.", show: true });
          setIsProcessing(false);
          return;
        }
        // 2025-08-09 Joe: Backend code also reserve, here also reserve, which doesn't make sense
        // const creditsReserved = await reserveCredits(user.id, orderId, creditsToUse);
        // if (!creditsReserved) {
        //   setNotification({ message: "Failed to reserve credits. Please try again or contact support.", show: true });
        //   return;
        // }
      }

      console.log("body:", {main_order: orderRequestBody, sub_orders: orderBodies});
      const { data: paymentParams, error: createOrderError } = await supabase.functions.invoke("client-create-order-v12", {
        body: {
          main_order: orderRequestBody,
          sub_orders: orderBodies,
          ...(promoCodeApplied ? { promo_code: promoCodeApplied.code } : {}),
          ...(promoDiscount > 0 ? { promo_discount_amount: promoDiscount } : {}),
          // Pre-promo, pre-credits subtotal — the same basis validate-promo-code
          // scored at Apply time, so the backend re-check agrees with the preview.
          pre_discount_total: discountedTotal,
        },
      });

      // Conflict check start
      if (createOrderError) {
        let errorMessage = "Failed to make booking. Please try again or contact support.";

        // Check if the error object has a 'context' property from the Supabase Function invocation
        if (createOrderError.context && createOrderError.context.status) {
          const status = createOrderError.context.status;
          const backendBody = await createOrderError.context.json(); // This should be the JSON body from your function's response

          if (status === 400) {
            errorMessage = backendBody?.details || "Invalid request details provided.";
          } else if (status === 409) {
            // This is the key for handling conflicts (timeslot taken, already booked, etc.)
            errorMessage = backendBody?.details || "The selected timeslot is no longer available. Please choose a different one.";
          } else if (status === 410) {
            // For expired pending bookings on the backend
            errorMessage = backendBody?.details || "Your pending booking expired or became invalid. Please start a new booking.";
          } else if (status === 500) {
            errorMessage = backendBody?.details || "Internal server error during order creation.";
          }
        } else {
          // Fallback for generic invocation errors (e.g., network issues, function not found)
          errorMessage = createOrderError.message || errorMessage;
        }

        setNotification({ message: errorMessage, show: true });
        if (useCredits && creditsToUse > 0) {
          // If credits were reserved but order creation failed, attempt to delete the pending reservation

          const { data: cleanUpResponse, error: cleanUpError } = await supabase.functions.invoke("client-delete-pending-credits-deduction", {
            body: { order_ids: [orderId]},
          });
          // await supabase.from("pending_credits_deduction").delete().eq("order_id", orderId).eq("user_id", user.id);
        }
        setIsProcessing(false);
        return;
      }
      // Conflict check end

      if (paymentFormRef.current) {
        const form = paymentFormRef.current;
        form.querySelector('input[name="merchant_id"]').value = paymentParams.merchant_id;
        form.querySelector('input[name="amount"]').value = paymentParams.amount;
        form.querySelector('input[name="orderid"]').value = paymentParams.order_id;
        form.querySelector('input[name="currency"]').value = paymentParams.currency;
        form.querySelector('input[name="vcode"]').value = paymentParams.vcode;
        form.querySelector('input[name="bill_name"]').value = formData.billingName;
        form.querySelector('input[name="bill_email"]').value = formData.billingEmail;
        form.querySelector('input[name="bill_mobile"]').value = formData.billingMobile.replace(/\s/g, "");
        form.querySelector('input[name="bill_desc"]').value = billDesc;
        form.querySelector('input[name="b_addr1"]').value = fixedBillingAddress;
        form.querySelector('input[name="returnurl"]').value = paymentParams.return_url;
        form.querySelector('input[name="notifyurl"]').value = paymentParams.notify_url;
        form.querySelector('input[name="callbackurl"]').value = paymentParams.callback_url;
        form.querySelector('input[name="metadata"]').value = JSON.stringify({ booking_type: bookingType });
        form.querySelector('input[name="waittime"]').value = paymentParams.waittime;
        form.querySelector('input[name="idempotency_key"]').value = paymentParams.idempotency_key;
        form.querySelector('input[name="guest_checkout"]').value = "0";

        // Log parameters for debugging
        const params = new FormData(form);
        console.log("Payment parameters being sent:", Object.fromEntries(params));

        form.submit();
      }
    } else { // This block handles completely free bookings (totalPayable === 0)
      // const { error: orderInsertError } = await supabase.from("orders").insert(orderRequestBody);
      // if (orderInsertError) {
      //   console.error("CourtCheckout.js: Error inserting order for credited booking:", orderInsertError);
      //   setNotification({ message: "Failed to record order. Please try again or contact support.", show: true });
      //   return;
      // }

      const { data: createFreeOrderResponse, error: createFreeOrderError } = await supabase.functions.invoke("client-create-order-free-v8", {
        body: { order_request_body: orderRequestBody, sub_orders: orderBodies, booking_type: bookingType, use_credits: useCredits, credits_to_use: creditsToUse },
      });
      // const { success, message: freeBookingMessage } = await insertFreeBooking(user, orderId, bookingType, bookingMetadata);
      if (createFreeOrderError) {
        console.error("CourtCheckout.js: Failed to confirm free booking:", createFreeOrderError);
        setNotification({ message: createFreeOrderError?.message || "Failed to confirm booking. Please try again.", show: true });
        setIsProcessing(false);
        return;
      }

      // if (useCredits && creditsToUse > 0) {
      //   const creditsUpdated = await updateUserCredits(user.id, creditsToUse);
      //   if (!creditsUpdated) {
      //     console.error("CourtCheckout.js: Booking confirmed, but failed to apply credits for free booking.");
      //     setNotification({ message: "Booking confirmed, but failed to apply credits. Please contact support.", show: true });
      //     return;
      //   }
      // }

      setNotification({ message: "Booking confirmed successfully!", show: true });
      setTimeout(() => navigate("/profile", { state: { selectedProfile: true } }), 2000);
    }
  };

  if (!isFullyLoaded) return <div className="loading-spinner-container"><div className="loading-spinner"></div></div>;
  if (!isAuthenticated) return null;

  return (
    <div className="checkout-container">
      <Navbar
        selectedSport={selectedSport}
        selectedBookingType={null}
        onBookingTypeSelect={(type) => navigate("/", { state: { selectedBookingType: type } })}
        onProfileClick={() => navigate("/profile", { state: { selectedProfile: true } })}
        isProfileActive={selectedProfile || false}
      />
      <div className="checkout-form">
        <div className="checkout-content">
          <div className="checkout-left">
            <div className="checkout-section">
              <h2 className="checkout-section-header">Billing Information</h2>
              <div className="form-group">
                <label htmlFor="billingName">Full Name <span className="required-marker">*</span></label>
                <input
                  type="text"
                  id="billingName"
                  name="billingName"
                  value={formData.billingName}
                  onChange={(e) => {
                    handleChange(e.target.name, e.target.value);
                    debouncedValidate(e.target.name, e.target.value);
                  }}
                  className="checkout-input"
                  placeholder="Enter your full name"
                  autoComplete="name"
                />
                {formErrors.billingName && <span className="error">{formErrors.billingName}</span>}
              </div>
              <div className="form-group">
                <label htmlFor="billingEmail">Email Address <span className="required-marker">*</span></label>
                <input
                  type="email"
                  id="billingEmail"
                  name="billingEmail"
                  value={formData.billingEmail}
                  onChange={(e) => {
                    handleChange(e.target.name, e.target.value);
                    debouncedValidate(e.target.name, e.target.value);
                  }}
                  className="checkout-input"
                  placeholder="Enter your email"
                  autoComplete="email"
                />
                {formErrors.billingEmail && <span className="error">{formErrors.billingEmail}</span>}
              </div>
              <div className="form-group" ref={phoneInputContainerRef}>
                <label htmlFor="bookingMobile">Mobile Number <span className="required-marker">*</span></label>
                <input
                  type="tel"
                  name="billingMobile"
                  id="billingMobile-native"
                  autoComplete="tel"
                  style={{ position: "absolute", opacity: 0, height: 0, pointerEvents: "none" }}
                  onChange={(e) => {
                    handleChange("billingMobile", e.target.value);
                    debouncedValidate("billingMobile", e.target.value);
                  }}
                  value={formData.billingMobile}
                />
                <PhoneInput
                  international
                  value={formData.billingMobile}
                  onChange={(value) => {
                    handleChange("billingMobile", value);
                    debouncedValidate("billingMobile", value);
                  }}
                  onBlur={handlePhoneBlur}
                  placeholder="Enter your phone number (e.g., +12025550123)"
                  inputRef={phoneInputRef}
                  inputProps={{ name: "billingMobile", autoComplete: "tel", type: "tel", id: "billingMobile" }}
                />
                {formErrors.billingMobile && <span className="error">{formErrors.billingMobile}</span>}
              </div>
            </div>
          </div>
          <div className="checkout-right">
            <div className="checkout-section">
              <h2 className="checkout-section-header">Order Summary</h2>
              <div className="order-summary">
                <div className="order-items-scrollable">
                  {orderItems.length > 0 ? (
                    orderItems.map((item, index) => (
                      <div className="summary-item" key={index}>
                        <span style={{ whiteSpace: "pre-line" }}>{item.type} - {item.details}</span>
                        <span style={{ whiteSpace: "pre-line" }}>
                          {item.type === "Credits Applied"
                            ? `- RM ${Math.abs(item.price).toFixed(2)}`
                            : item.type === "Membership Discount"
                            ? `- RM ${Math.abs(item.membershipDiscountPrice).toFixed(2)}` 
                            : item.type === "Promotion Discount"
                            ? `- RM ${Math.abs(item.companyDiscountPrice).toFixed(2)}` 
                            : item.price === 0 
                            ?  "" 
                            : `RM ${item.basePrice.toFixed(2)}`}
                        </span>
                      </div>
                    ))
                  ) : (
                    <div className="summary-item"><span>No items in the order</span></div>
                  )}
                </div>
                {membershipStatus === 'ytl_staff' && ytlRemainingQuota !== null && (
                  <div style={{ padding: '10px', marginBottom: '10px', backgroundColor: '#e8f4fd', borderRadius: '8px', fontSize: '14px', color: '#1a73e8' }}>
                    YTL Corporate Staff Discount: {ytlRemainingQuota > 0
                      ? `${ytlRemainingQuota} discounted session${ytlRemainingQuota !== 1 ? 's' : ''} remaining this week`
                      : 'Weekly discount limit reached (2/2 used)'}
                  </div>
                )}
                {promoDiscount > 0 && promoCodeApplied && (
                  <div className="summary-item">
                    <span>Promo Code Discount ({promoCodeApplied.code})</span>
                    <span>- RM {promoDiscount.toFixed(2)}</span>
                  </div>
                )}
                <div className="order-totals-static">
                  {/* Promo Code Section */}
                  <div className="promo-code-section">
                    {!promoCodeApplied ? (
                      <div className="promo-code-input-row">
                        <input
                          type="text"
                          className="promo-code-input"
                          placeholder="Enter promo code"
                          value={promoCode}
                          onChange={(e) => { setPromoCode(e.target.value.toUpperCase()); setPromoError(''); }}
                          onKeyDown={(e) => e.key === 'Enter' && handleApplyPromoCode()}
                          disabled={isPromoLoading}
                        />
                        <button
                          className="promo-apply-btn"
                          onClick={handleApplyPromoCode}
                          disabled={isPromoLoading || !promoCode.trim()}
                        >
                          {isPromoLoading ? 'Applying...' : 'Apply'}
                        </button>
                      </div>
                    ) : (
                      <div className="promo-applied-row">
                        <span className="promo-applied-label">
                          Promo: <strong>{promoCodeApplied.code}</strong>
                          {promoCodeApplied.description && <span className="promo-description"> — {promoCodeApplied.description}</span>}
                        </span>
                        <span className="promo-applied-discount">-RM {promoDiscount.toFixed(2)}</span>
                        <button className="promo-remove-btn" onClick={handleRemovePromoCode}>&#x2715;</button>
                      </div>
                    )}
                    {promoError && <p className="promo-error">{promoError}</p>}
                  </div>
                  {availableCredits > 0 && (
                    <div className="credits-section">
                      <label className="credits-label">
                        <input type="checkbox" checked={useCredits} onChange={handleCreditsToggle} />
                        Use Credits (Available: RM {availableCredits.toFixed(2)})
                      </label>
                      {useCredits && (
                        <div className="credits-input-container">
                          <label>Amount to Use:</label>
                          <span className="credits-input" style={{ border: "none", background: "transparent", padding: "8px" }}>
                            RM {creditsToUse.toFixed(2)}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="summary-subtotal">
                    <span>Subtotal</span>
                    <span>RM {finalTotal.toFixed(2)}</span>
                  </div>
                  <div className="summary-subtotal">
                    <span>{SST_LABEL}</span>
                    <span>RM {(Math.max(0, finalTotal - addOnSubtotal) * SST_RATE).toFixed(2)}</span>
                  </div>
                  <div className="line-container">
                    <div className="horizontal-line"></div>
                  </div>
                  <div className="summary-total">
                    <span>Final Total</span>
                    <span>RM {(finalTotal + Math.max(0, finalTotal - addOnSubtotal) * SST_RATE).toFixed(2)}</span>
                  </div>
                </div>
              </div>
              <button
                onClick={handlePlaceOrder}
                className="submit-button"
                aria-label="Place order"
                disabled={isPriceLoading}
              >
                Place Order
              </button>
              {useCredits && creditsToUse > 0 && (
                <p style={{ color: "#d32f2f", fontSize: "0.85rem", marginTop: "10px", textAlign: "center" }}>
                  Note: Credits are held during payment for 3 minutes and will be returned if the payment fails.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <form
        ref={paymentFormRef}
        action="https://pay.fiuu.com/RMS/pay/pickledepot/"
        method="POST"
        style={{ display: "none" }}
        accept-charset="UTF-8"
      >
        <input type="hidden" name="merchant_id" value="" />
        <input type="hidden" name="amount" value="" />
        <input type="hidden" name="orderid" value="" />
        <input type="hidden" name="currency" value="" />
        <input type="hidden" name="vcode" value="" />
        <input type="hidden" name="bill_name" value="" />
        <input type="hidden" name="bill_email" value="" />
        <input type="hidden" name="bill_mobile" value="" />
        <input type="hidden" name="bill_desc" value="" />
        <input type="hidden" name="b_addr1" value="" />
        <input type="hidden" name="returnurl" value="" />
        <input type="hidden" name="notifyurl" value="" />
        <input type="hidden" name="callbackurl" value="" />
        <input type="hidden" name="metadata" value="" />
        <input type="hidden" name="waittime" value="" />
        <input type="hidden" name="idempotency_key" value="" />
        <input type="hidden" name="guest_checkout" value="0" />
      </form>
      {notification.show && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Notification</h2>
            <p>{notification.message}</p>
            <button className="modal-close-button" onClick={handleCloseNotification}>
              <FontAwesomeIcon icon={faTimes} /> Got It
            </button>
          </div>
        </div>
      )}
      <ConfirmationModal
        isOpen={showConfirmationModal}
        onClose={() => setShowConfirmationModal(false)}
        onConfirm={handleSubmit}
      />
      {isProcessing && (
        <div className="modal-overlay" style={{ zIndex: 9999 }}>
          <div className="loading-spinner-container" style={{ background: 'transparent', height: 'auto' }}>
            <div className="loading-spinner"></div>
            <span style={{ marginTop: '15px', color: '#576f3f', fontFamily: '"Manrope", sans-serif', fontSize: '0.95rem' }}>Processing your booking...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default CourtCheckout;